import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { Add } from "@mui/icons-material";

import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { AddEditTool, ToolsList } from "../../components/tools";
import { CREATE_TOOL } from "../../constants";
import { useHasPermission } from "../../utils";

export const Tools = () => {
  const [storeId, setStoreId] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [reload, setReload] = useState(0);

  const { user } = useSelector((state) => state.user);
  const hasToolCreate = useHasPermission(CREATE_TOOL);

  useEffect(() => {
    if (user) setStoreId(user?.company?.storeId);
  }, [user]);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleReload = () => setReload((prev) => prev + 1);

  const buttons = [
    hasToolCreate && {
      buttonText: "Add Tool",
      buttonIcon: Add,
      onClick: handleOpenModal,
    },
  ];
  return (
    <>
      <PageLayout>
        {/* header section */}
        <Box sx={{ position: "relative", zIndex: 1 }}>
          <PageHeader
            // title
            title="Tools"
            subtitle={`${totalCount} tools`}
            // button
            buttons={buttons}
          />
        </Box>

        {/* table section */}
        <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
          <ToolsList
            totalCount={totalCount}
            setTotalCount={setTotalCount}
            storeId={storeId}
            onSuccess={handleReload}
            reloadData={reload}
          />
        </Box>
      </PageLayout>

      {/* add tool modal */}
      <AddEditTool open={openModal} storeId={storeId} onClose={handleCloseModal} onSuccess={handleReload} />
    </>
  );
};
